import { Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { firstValueFrom } from 'rxjs'

interface AnalyticsConfig {
  googleTagId?: string
  gaMeasurementId?: string
  googleAdsId?: string
  googleAdsConversionLabel?: string
}

interface FrontendConfig {
  apiUrl: string
  loginRedirect: string
  authTokenHeader: string
  fileUpload: {
    maxSize: number
  }
  analytics?: AnalyticsConfig
}

@Injectable({
  providedIn: 'root',
})
export class ConfigService {
  private config: FrontendConfig = {
    apiUrl: '/api',
    loginRedirect: '/dashboard',
    authTokenHeader: 'Authorization',
    fileUpload: {
      maxSize: 5242880,
    },
  }

  constructor(private http: HttpClient) { }

  async loadConfig(): Promise<void> {
    const configUrl = '/config'

    try {
      const remoteConfig = await firstValueFrom(this.http.get<Partial<FrontendConfig>>(configUrl))
      this.config = {
        ...this.config,
        ...remoteConfig,
        fileUpload: {
          ...this.config.fileUpload,
          ...(remoteConfig.fileUpload ?? {}),
        },
      }
    } catch (err) {
      console.error('Error loading configuration from backend:', err)
    }
  }

  getApiUrl(): string {
    return this.config.apiUrl
  }

  getLoginRedirect(): string {
    return this.config.loginRedirect
  }

  getAuthTokenHeader(): string {
    return this.config.authTokenHeader
  }

  getMaxFileSize(): number {
    return this.config.fileUpload.maxSize
  }

  getGaMeasurementId(): string {
    return this.config.analytics?.gaMeasurementId ?? ''
  }

  getGoogleTagId(): string {
    return this.config.analytics?.googleTagId ?? ''
  }

  getGoogleAdsId(): string {
    return this.config.analytics?.googleAdsId ?? ''
  }

  getGoogleAdsConversionLabel(): string {
    return this.config.analytics?.googleAdsConversionLabel ?? ''
  }
}
